var _style, _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRegistrationModify = function SvgRegistrationModify(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.2 43.2",
    style: {
      enableBackground: "new 0 0 46.2 43.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#353535;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,1.4c-0.6,0.1-1.2,0.4-1.7,0.7c-0.3,0.2-1,0.9-1.6,1.5l-1.2,1.2l3,2.9l2.9,3l1.3-1.3 c1.4-1.4,1.7-1.8,2-2.6c0.6-1.5,0.2-3.2-1-4.3C41.8,1.6,40.4,1.1,39.1,1.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -14.8121,
    cy: 62.562,
    r: 1,
    gradientTransform: "matrix(92.6145 105.2882 105.4931 -92.7949 -5247.8999 7324.8428)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F11E37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B10015"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,13.3c-5.4,5.4-6.7,6.7-6.7,6.9c0,0.1-0.3,1.6-0.6,3.2c-0.4,1.9-0.6,3-0.5,3.1c0.1,0.3,0.3,0.5,0.6,0.6 c0.3,0.1,6.3-1.1,6.6-1.3c0.1-0.1,3.2-3.1,6.8-6.7l6.6-6.6l-2.9-2.9c-1.6-1.6-2.9-2.9-3-2.9C32.9,6.6,29.8,9.6,26.2,13.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -16.0258,
    cy: 62.4543,
    r: 1,
    gradientTransform: "matrix(156.4704 151.5959 151.733 -156.6118 -7015.9668 12170.4062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F11E37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BB2B3C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.3,8c-1.6,0.2-3,1.3-3.7,2.8C4,11.9,4,11.1,4,24.6c0,13.6,0,12.7,0.6,13.9c0.6,1.1,1.6,2,2.9,2.5l0.6,0.2 h12.6h12.6l0.6-0.2c1.6-0.5,2.8-1.8,3.3-3.5c0.1-0.5,0.1-1,0.1-7.8v-7.3l-0.2-0.4c-0.3-0.6-0.9-0.9-1.5-0.8c-0.5,0-1,0.3-1.3,0.8 l-0.2,0.3l0,7.2c0,6.6,0,7.2-0.2,7.4c-0.2,0.3-0.6,0.7-1,0.8c-0.2,0.1-3.8,0.1-12.4,0.1l-12.1,0l-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.5 l-0.2-0.3l0-12.2c0-11.9,0-12.2,0.1-12.5c0.1-0.2,0.3-0.4,0.4-0.5c0.5-0.5,0.1-0.5,7.7-0.5c5.3,0,7,0,7.3-0.1 c0.4-0.1,0.9-0.6,1.1-1.1c0.2-0.7-0.1-1.5-0.8-1.9L22.8,8l-7,0C11.9,8,8.6,8,8.3,8z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistrationModify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RegistrationModify.8796adf9.svg";
export { ForwardRef as ReactComponent };